import { FieldProps } from './FieldProps';
import { SparkField } from './SparkField/SparkField';

export function Inn(props: FieldProps) {
  const {
    className,
    label = 'ИНН',
    required = false,
    isSendingStatus,
    sendFormFillAnalytics,
  } = props;

  return (
    <SparkField
      className={className}
      type="inn"
      additionalType="company"
      label={label}
      required={required}
      disabled={isSendingStatus}
      sendFormFillAnalytics={sendFormFillAnalytics}
    />
  );
}
